import React from "react";
import { STICKY } from "@/constants/testIds";
import { CONTACT } from "@/constants/site";
import { useLang } from "@/i18n/LanguageContext";
import { Phone, Mail } from "lucide-react";

export default function StickyMobileCTA() {
  const { t } = useLang();
  return (
    <div className="md:hidden fixed bottom-0 left-0 right-0 z-40 grid grid-cols-2 border-t border-white/10 bg-[#0A0A0A]">
      <a
        data-testid={STICKY.call}
        href={CONTACT.phoneHref}
        className="flex items-center justify-center gap-2 py-4 bg-[#F5B800] text-black font-black uppercase tracking-[0.15em] text-xs"
      >
        <Phone size={16} strokeWidth={2.5} />
        {t.sticky.call}
      </a>
      <a
        data-testid={STICKY.email}
        href="#contact"
        className="flex items-center justify-center gap-2 py-4 bg-[#141414] text-white font-black uppercase tracking-[0.15em] text-xs border-l border-white/10"
      >
        <Mail size={16} strokeWidth={2.5} />
        {t.sticky.email}
      </a>
    </div>
  );
}
